import template from './stModal.html';
import controller from './stModal.controller';

let stModalComponent = {
    restrict: 'E',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    template,
    controller,
    controllerAs: 'vm'
};

export default stModalComponent;



// WEBPACK FOOTER //
// ./client/app/common/stModal/stModal.component.js